import { SERVICES, IMAGES } from "@/data/site";
import { ServiceCard } from "@/components/ServiceCard";
import { LeadForm } from "@/components/LeadForm";
import { BrandsRow } from "@/components/BrandsRow";
import { WarrantyBlock } from "@/components/WarrantyBlock";
import { AfterHoursCallout } from "@/components/AfterHoursCallout";
import { PayLaterMessage } from "@/components/PayLaterMessage";
import { Seo } from "@/components/Seo";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo title="AC Services with Upfront Pricing | Central Air Depot" description="Flat-rate AC services in South Florida: $67/vent duct cleaning, $99 diagnostic, $199 smart thermostat install, $379 UV purification. Book online." />
      <section className="relative">
        <img src={IMAGES.repair} alt="Technician servicing a residential air conditioning system" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative max-w-7xl mx-auto px-4 py-20 sm:py-28">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-ice mb-3">Services &amp; Pricing</p>
          <h1 className="text-4xl sm:text-5xl tracking-tighter leading-none font-black text-white max-w-2xl">Every service, priced upfront</h1>
          <p className="text-base sm:text-lg text-zinc-100 mt-4 max-w-xl">No hourly meters, no mystery fees. You approve the flat price before we start.</p>
        </div>
      </section>
      <section className="bg-brand-subtle">
        <div className="max-w-7xl mx-auto px-4 py-16 sm:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => (
              <ServiceCard key={s.id} service={s} highlight={s.id === "maintenance-plan"} />
            ))}
          </div>
          <div className="mt-10">
            <AfterHoursCallout />
          </div>
          <div className="mt-6">
            <PayLaterMessage />
          </div>
        </div>
      </section>
      <BrandsRow />
      <WarrantyBlock />
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-4 py-16 sm:py-24">
          <LeadForm heading="Not sure what you need?" subtext="Describe the problem and a specialist will recommend the right fix — free." />
        </div>
      </section>
    </div>
  );
}
